import apiBranch from '@/api/branch'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteBranchStart: '[delete branch] Delete branch start',
  deleteBranchSuccess: '[delete branch] Delete branch success',
  deleteBranchFailure: '[delete branch] Delete branch failure'
}

export const actionTypes = {
  deleteBranch: '[delete branch] Delete branch'
}

const mutations = {
  [mutationTypes.deleteBranchStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteBranchSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteBranchFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteBranch](context, {id}) {
    context.commit(mutationTypes.deleteBranchStart)
    return new Promise(resolve => {
      apiBranch
        .deleteBranch(id)
        .then(response => {
          context.commit(mutationTypes.deleteBranchSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteBranchFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
